import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError, debounceTime, distinctUntilChanged, filter, map, switchMap } from 'rxjs/operators';
import { BaseSearchService } from '@src/core/services/base-search.service';

@Injectable({
  providedIn: 'root',
})
export class SearchService<
  Service extends BaseSearchService<FilterType, SortType, ReturnType>,
  FilterType,
  SortType,
  ReturnType,
> {
  startSearch(service: Service, filter: FilterType | null, sort: SortType | null = null): void {
    service.filter$.next(filter);
    service.sort$.next(sort);
    service.pagination$.next(0);
  }

  startSearchNextPage(service: Service): void {
    service.pagination$.next(service.pagination$.value + 1);
  }

  resetPagination(service: Service): void {
    service.pagination$.next(0);
  }

  searchFilter(service: Service): Observable<ReturnType | null> {
    return service.filter$
      .pipe(
        filter(filter => !!filter),
        debounceTime(500),
        distinctUntilChanged(),
        switchMap(filter => {
          return service.search(service.pagination$.value, filter!, service.sort$.value).pipe(
            catchError(() => {
              // TODO handle error
              return of(null);
            }),
          );
        }),
      )
      .pipe(
        map(result => {
          return result;
        }),
      );
  }

  searchNextPage(service: Service): Observable<ReturnType | null> {
    return service.pagination$
      .pipe(
        filter(pagination => !!service.filter$.value && !!pagination),
        debounceTime(500),
        distinctUntilChanged(),
        switchMap(pagination => {
          return service.search(pagination, service.filter$.value!, service.sort$.value).pipe(
            catchError(() => {
              // TODO handle error
              return of(null);
            }),
          );
        }),
      )
      .pipe(
        map(result => {
          return result;
        }),
      );
  }
}
